import ChipsTableCellComponent from "../ChipsTableCell.Component";

export const mrqMaterialsMcsDataCols = [
  {
    accessorKey: "mrqNumber",
    header: "Mrq #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      const chips =
        row.original.mrqMaterials?.map((m) => {
          return m?.mrq;
        }) || [];
      return <ChipsTableCellComponent type="mrq" chips={chips} />;
    },
  },
  {
    accessorKey: "poNumber",
    header: "PO #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      const chips =
        row.original.poMaterials?.map((m) => {
          return m?.po;
        }) || [];
      return <ChipsTableCellComponent type="po" chips={chips} />;
    },
  },
  {
    accessorKey: "mrvNumber",
    header: "MRV #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      // console.log({ mrvRow: row.original.mrvMrqMaterials?.[0]?.quantity });
      const chips =
        row.original.mrvMrqMaterials?.map((m) => {
          return m.mrv;
        }) || [];
      return row.original.mrvMrqMaterials?.[0]?.quantity ? (
        <ChipsTableCellComponent type="mrv" chips={chips} />
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "srvNumber",
    header: "SRV #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      const chips =
        row.original.srvMaterials?.map((m) => {
          return m?.srv;
        }) || [];
      return <ChipsTableCellComponent type="srv" chips={chips} />;
    },
  },
  {
    accessorKey: "heatNumber",
    header: "Heat #",
    enableEditing: false,
    size: 70,
  },

  {
    accessorKey: "actions",
    header: "Actions",
    enableEditing: false,
    size: 30,
  },
];
